import { RICatalogCode001A, RICatalogCode002, RICatalogCode003, RICatalogCode003A, RICatalogCode004 } from 'pages/reference-implementation/utils/RICatalogCode';
import {
    ApplicationGateWayURLCatalogDefinitionID,
    MdtCatalogDefinitionId,
    SecurityToolCatalogDefinitionId,
    InternalApplicationGateWayURLCatalogDefinitionID,
    ExternalPublicLoadBalancerURLCatalogDefinitionID,
} from './catalogDefinitionId';

export const scopedCatalogs = [
    RICatalogCode001A,
    RICatalogCode002,
    RICatalogCode003,
    RICatalogCode003A,
    RICatalogCode004,
    ...ApplicationGateWayURLCatalogDefinitionID,
    ...MdtCatalogDefinitionId,
    ...SecurityToolCatalogDefinitionId,
    ...InternalApplicationGateWayURLCatalogDefinitionID,
    ...ExternalPublicLoadBalancerURLCatalogDefinitionID,
];

export default scopedCatalogs;
